// Step1_AccountPersonal.jsx
import { BASE_URL } from "@/utils/constants";
import TextInput from "@components/shared/TextInput";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";



export default function Step1_AccountPersonal({ values, errors, touched, setFieldValue }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [usernameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);


  const checkUsernameExists = async (username) => {
    if (!username) {
      setUsernameError("");
      return;
    }
    try {
      const res = await fetch(BASE_URL + `api/user/register/username`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username }),
      }, navigate);
      const data = await res.json();
      if (data) {
        setUsernameError(data.message);
      } else {
        setUsernameError(data.message);
      }
    } catch (error) {
      console.error("Failed to check USERNAME:", error);
      setUsernameError("Error checking username availability.");
    }
  };

  const checkEmailExists = async (email) => {
    if (!email) {
      setEmailError("");
      return;
    }
    try {
      const res = await fetch(BASE_URL + `api/user/register/email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }, navigate);
      const data = await res.json();
      if (data) {
        setEmailError(data.message);
      } else {
        setEmailError(data.message);
      }
    } catch (error) {
      console.error("Failed to check EMAIL:", error);
      setEmailError("Error checking email availability.");
    }
  };

  const checkMobileExists = async (mobile) => {
    if (!mobile) {
      setMobileError("");
      return;
    }
    try {
      const res = await fetch(BASE_URL + `api/user/register/mobile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile }),
      }, navigate);
      const data = await res.json();
      if (data) {
        setMobileError(data.message);
      } else {
        setMobileError(data.message);
      }
    } catch (error) {
      console.error("Failed to check MOBILE:", error);
      setMobileError("Error checking mobile number availability.");
    }
  };

  const sendOTP = async () => {
    const mobile = values.mobileNo;
    const email = values.email;

    if (!mobile || !email) {
      toast.error("Enter mobile & email first");
      return;
    }
    setOtpLoading(true);
    setOtpError("");
    try {
      const res = await fetch(BASE_URL + "api/user/register/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile, email }),
      });

      const data = await res.json();
      console.log("OTP response data:", data);

      if (data.success || data.status === 'success') {
        setOtpError("");
        toast.success("OTP sent successfully");
      } else {
        // setOtpError(data.message || "Failed to send OTP");
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("OTP error:", err);
      setOtpError("Failed to send OTP. Try again.");
    } finally {
      setOtpLoading(false);
    }
  };


  return (
    <div className="grid grid-cols-1 flex gap-2">
      <div className="flex flex-col">
        <TextInput
          label="Username"
          name="username"
          type="text"
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#ec7026] font-['Semantic/Strong'] text-gray-700 pl-10"
          labelClassName="text-[12px] font-bold"
          placeholder="Enter your username"
          errorClassName="text-red-600 font-['Semantic/Strong'] text-sm"
          onBlur={() => checkUsernameExists(values.username)}
          errorMessage={errors.username || (usernameError === "Username already exists" ? usernameError : "")}
          successMessage={usernameError === "Username is available" ? usernameError : ""}
          required={true}
          showUsernameRules={true}

        />
      </div>
      <div className="flex flex-col">
        <TextInput
          label="Email"
          name="email"
          type="text"
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#ec7026] font-['Semantic/Strong'] text-gray-700 pl-10"
          labelClassName="text-[12px] font-bold"
          placeholder="Enter your Email"
          errorClassName="text-red-600 font-['Semantic/Strong'] mt-1 text-sm"
          onBlur={() => checkEmailExists(values.email)}
          errorMessage={errors.email || (emailError === "Email already exists" ? emailError : "")}
          successMessage={emailError === "Email is available" ? emailError : ""}
          required={true}
        />
      </div>
      <div className="flex flex-col mb-1">
        <TextInput
          label="Mobile Number"
          name="mobileNo"
          type="text"
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#ec7026] font-['Semantic/Strong'] text-gray-700 pl-10"
          labelClassName="text-[12px] font-bold"
          placeholder="Enter your Mobile Number"
          errorClassName="text-red-600 font-['Semantic/Strong'] mt-1 text-sm"
          onBlur={() => checkMobileExists(values.mobileNo)}
          errorMessage={errors.mobileNo || (mobileError === "Mobile number already exists" ? mobileError : "")}
          successMessage={mobileError === "Mobile number is available" ? mobileError : ""}
          required={true}
        />
      </div>
      <button
        type="button"
        onClick={sendOTP}
        disabled={otpLoading}
        className={`flex items-center gap-2 text-[14px] border w-max px-4 py-2 rounded-lg
    ${otpLoading
            ? "bg-gray-200 text-gray-500 cursor-not-allowed"
            : "text-[rgba(236,112,38,1)] border-[rgba(236,112,38,1)] hover:bg-orange-50"
          }`}
      >
        {otpLoading && (
          <span className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
        )}

        {otpLoading ? "Sending OTP..." : "Click here to send OTP"}
      </button>

      <div className="flex flex-col gap-1">
        <p className="text-[12px] font-bold text-gray-700">Verify OTP</p>
        <p className="text-[11px] text-[rgba(33,37,41,0.75)]">Enter the verification code we just sent on your email address.</p>
        <div className="flex self-center gap-3 mt-1">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <input
              key={i}
              maxLength={1}
              type="text"
              inputMode="numeric"
              id={`otp-input-${i}`}
              value={values.otp?.[i] || ""}
              className="w-10 h-10 text-center border border-gray-300 rounded-xl text-lg 
               focus:outline-none focus:ring-2 focus:ring-[#ec7026] font-bold"
              onChange={(e) => {
                const value = e.target.value.replace(/\D/, "");
                setFieldValue(`otp.${i}`, value);

                if (value && i < 5) {
                  document.getElementById(`otp-input-${i + 1}`).focus();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !values.otp[i] && i > 0) {
                  document.getElementById(`otp-input-${i - 1}`).focus();
                }
              }}
            />
          ))}
        </div>
        {otpError && <div className="text-red-500 self-center text-[12px]">{otpError}</div>}

      </div>
    </div>
  );
}